import supabaseClient from '@/api/supabaseClient.ts';
import { ProductRepository } from '$/repositories/productRepository/ProductRepository.ts';

const productRepository = new ProductRepository(supabaseClient);
export default productRepository;
